import React from 'react';

import { CardContent } from '@material-ui/core';
import AddToAgendaComponent from 'components/MeshList/AddToAgendaComponent';
import MediaView from 'components/feed/MediaView';
import { PostHeader, PostText } from 'components/feed/PostFeedItem';
import styled, { css } from 'styled-components';
import { StyledTypography } from 'styles/common';

import { MESH_LIST_TABS } from 'constants/ProjectConstants';

const StyledAddToAgendaComponent = styled(AddToAgendaComponent)``;
export default function Feedback({ data, showAddToAgenda = false, isAppreciative }) {
  const { fromEmployee: from, createdDate, text, macrosRes, media } = data;
  return from ? (
    <Container $showAddToAgenda={showAddToAgenda}>
      {/* <StyledCardHeader
        avatar={<StyledAvatar size="smaller" src={from.getProfileImage()} />}
        action={
          <Typography color="textSecondary" variant="body2">
            {getHumanReadableDate(data.createdDate)}
          </Typography>
        }
        title={<StyledTypography weight={600}>{from.fullName}</StyledTypography>}
        subheader={from.designation}
      /> */}
      <HeaderContainer $showAddToAgenda={showAddToAgenda}>
        <PostHeader
          fromEmployee={from}
          createdDate={createdDate}
          border={false}
          visibilityType={data.visibilityType?.name}
          isFeedbackHeader
        />
        {showAddToAgenda ? (
          <StyledAddToAgendaComponent type={MESH_LIST_TABS.feedback.taskType} feedback={data} />
        ) : null}
      </HeaderContainer>

      <StyledCardContent>
        <Content display="inline">
          {/* <ColoredSpan isAppreciative={isAppreciative}>" </ColoredSpan> */}
          <StyledPostText text={text} macrosRes={macrosRes} />
          {/* <ColoredSpan isAppreciative={isAppreciative}> "</ColoredSpan> */}
        </Content>
        <MediaView media={media} />
      </StyledCardContent>
    </Container>
  ) : null;
}

const Container = styled.div`
  ${(props) =>
    props.$showAddToAgenda &&
    css`
      &:hover {
        ${StyledAddToAgendaComponent} {
          visibility: visible;
        }
      }
    `};
`;

const HeaderContainer = styled.div`
  ${(props) =>
    props.$showAddToAgenda &&
    css`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `};
`;

const ColoredSpan = styled.span`
  // color: ${(props) => (props.isAppreciative ? 'green' : 'red')};
  font-size: ${(props) => props.theme.typography.h6.fontSize};
`;

const StyledCardContent = styled(CardContent)`
  padding-left: 0;
  padding-right: 0;
  padding-top: 0px;
  padding-bottom: 1rem !important;
`;

const Content = styled(StyledTypography)`
  line-height: 1;
`;

const StyledPostText = styled(PostText)`
  display: inline;
`;

Feedback.defaultProps = {
  data: {},
};
